// componnents/UI/ErrorMessage.jsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import './UI.css';

const ErrorMessage = ({ 
  message = 'Something went wrong. Please try again.',
  onRetry = null,
  retryText = 'Try Again',
  variant = 'section',
}) => {
  const className = [
    'error-container',
    variant === 'fullPage' ? 'error-container--full-page' : '',
    variant === 'inline' ? 'error-container--inline' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <AlertCircle size={48} className="error-icon" />
      <p className="error-text">{message}</p>
      {onRetry && (
        <button type="button" className="retry-btn" onClick={onRetry}>
          {retryText}
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;

